import { render, staticRenderFns } from "./buddha-time.vue?vue&type=template&id=f0d1efb2&scoped=true"
import script from "./buddha-time.vue?vue&type=script&lang=js"
export * from "./buddha-time.vue?vue&type=script&lang=js"
import style0 from "./buddha-time.vue?vue&type=style&index=0&id=f0d1efb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d1efb2",
  null
  
)

export default component.exports